<template>
  <div class="people-list-referrals">
    <v-row no-gutters>
      <div class="selection-section-container">
        <SelectionSection
          @selectedAll="selectedAll"
          @unSelectedAll="unSelectedAll"
          :count-selected="countOfSelectedPeople()"
          :total-items="this.peoplePool.length"
        />
      </div>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="extra-margin">
          <div v-for="(person, index) in peoplePool" :key="index">
            <div class="list-item">
              <v-btn
                :ripple="false"
                block
                color="white"
                class="list-item-btn"
                @click.stop="showEditDialog(person)"
              >
                <div class="list-item-text">
                  <v-checkbox
                    v-model="person.checked"
                    :disabled="!person.email"
                    color="primary"
                    @click="handleCheckboxClick"
                  >
                    <template #label>
                      <div>
                        <span class="list-item-name">{{
                          person.fullName
                        }}</span>
                        <span
                          v-show="person.kinship"
                          class="list-item-separator"
                          >-</span
                        >
                        <span class="list-item-more-info">{{
                          formatPersonKinship(person.kinship)
                        }}</span>
                        <NoEmailAssigned v-if="!person.email" />
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-btn>
            </div>
          </div>
        </div>
        <v-row class="add-person-button-container">
          <v-col cols="12" md="12" class="py-0 mt-6 mb-6">
            <AlternativeButton
              :title="'Add a person'"
              @gradientButtonClicked="showCreateDialog()"
            />
          </v-col>
        </v-row>
      </v-col>
      <PersonDialog
        v-model="showDialog"
        :person-to-update="personToUpdate"
        :people-list-for-dialog="[]"
        :relation="relation"
        :display-existing-people="false"
        :show-delete="false"
        :addPersonEmailRequired="true"
        @existingPersonSelectedWithMissingData="
          existingPersonSelectedWithMissingData
        "
        @modalClosed="modalClosed"
        @personCreated="personCreated"
      />
    </v-row>
  </div>
</template>

<script>
  import PersonDialog from '../people/PersonDialog.vue';
  import NoEmailAssigned from './NoEmailAssigned.vue';
  import { formatKinship } from '../../constants/js/people.js';
  import AddCompanyAsTrusteeBtn from '../people/AddCompanyAsTrusteeBtn.vue';
  import CompanyTrusteeListItem from '../people/CompanyTrusteeListItem.vue';
  import SelectionSection from './SelectionSection.vue';

  export default {
    name: 'AllPeopleList',
    components: {
      PersonDialog,
      NoEmailAssigned,
      AddCompanyAsTrusteeBtn,
      CompanyTrusteeListItem,
      SelectionSection,
    },
    props: {
      testator: { type: Object, required: true },
      people: { type: Array, required: true },
      peopleForDialog: { type: Array },
      limit: { type: Number },
      relation: { type: String, required: true },
    },
    watch: {
      people(newValue) {
        this.peoplePool = newValue.map(person => {
          return {
            ...person,
            checked: this.personWasChecked(person),
          };
        });
      },
    },
    data(props) {
      return {
        showDialog: false,
        peoplePool: props.people.map(person => {
          return {
            ...person,
            checked: false,
          };
        }),
        personToUpdate: {
          fullName: null,
          dateOfBirth: null,
          kinship: null,
        },
      };
    },
    methods: {
      handleCheckboxClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.$emit('peopleSelected', this.allPeopleSelected());
      },
      countOfSelectedPeople() {
        return this.peoplePool.filter(person => {
          return person.checked;
        }).length;
      },
      selectedAll() {
        this.peoplePool.map(person => {
          person.checked = true;
        });
        this.$emit('peopleSelected', this.allPeopleSelected());
      },
      unSelectedAll() {
        this.peoplePool.map(person => {
          person.checked = false;
        });
        this.$emit('peopleSelected', this.allPeopleSelected());
      },
      personWasChecked(personToValidate) {
        const previousPerson = this.peoplePool.find(
          person => person.id == personToValidate.id
        );

        if (previousPerson) {
          return previousPerson.checked;
        }

        return false;
      },
      allPeopleSelected() {
        return this.peoplePool.filter(person => {
          return person.checked;
        });
      },
      modalClosed() {
        this.personToUpdate = {
          fullName: null,
          dateOfBirth: null,
          kinship: null,
        };
      },
      personCreated() {
        this.$emit('personCreated');
      },
      existingPersonSelectedWithMissingData(person) {
        this.personToUpdate = person;
      },
      showEditDialog(person) {
        if (person.email) {
          person.checked = !person.checked;
          this.$emit('peopleSelected', this.allPeopleSelected());
        } else {
          this.personToUpdate = person;
          this.showDialog = true;
        }
      },
      showCreateDialog() {
        this.showDialog = true;
        dataLayer.push({
          event: 'referral_addperson_popup',
          omuserid: this.$store.getters?.userId,
          omtid: this.$store.getters?.omtId,
        });
      },
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
  };
</script>

<style scoped lang="scss">
  .extra-margin {
    margin-bottom: 25px;
  }

  .add-person-button-container {
    display: flex;
    flex-direction: column;
  }
  .add-item-btn {
    margin-bottom: 12px !important;
  }

  .people-list-referrals {
    .list-item-text {
      span {
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
        color: var(--v-Onyx-base, #282828);
      }
    }

    .selection-section-container {
      padding-bottom: 6px;
      width: 100%;
    }
  }
</style>
